import messageRingUrl from '@/assets/media/messageRing.mp3'
import notificationRingUrl from '@/assets/media/notification.mp3'

// Жесты, после которых мобильные браузеры разрешают звук. touchstart iOS жестом не считает.
const UNLOCK_EVENTS = ['touchend', 'click', 'keydown']

let soundAlertInstance: ReturnType<typeof createSoundAlertService>

function createSoundAlertService() {
    const messageAudio = new Audio(messageRingUrl)
    const notificationAudio = new Audio(notificationRingUrl)
    let unlocked = false
    let unlocking = false

    // Глушим через muted: на iOS volume только для чтения. Играющий звук не трогаем — ему уже разрешено.
    const unlockOne = (audio: HTMLAudioElement) => {
        if (!audio.paused) {
            return Promise.resolve()
        }
        audio.muted = true
        return audio.play().then(() => {
            audio.pause()
            audio.currentTime = 0
        }).finally(() => {
            audio.muted = false
        })
    }

    // iOS разрешает play() элементу, только если тот уже запускался внутри жеста пользователя.
    const unlock = () => {
        if (unlocked || unlocking) {
            return
        }
        unlocking = true
        Promise.all([unlockOne(messageAudio), unlockOne(notificationAudio)])
            .then(() => {
                unlocked = true
                setUnlockListeners(false)
            })
            .catch(() => {})
            .finally(() => {
                unlocking = false
            })
    }

    // capture: на document перехват срабатывает раньше любого @click.stop
    const setUnlockListeners = (enabled: boolean) => {
        UNLOCK_EVENTS.forEach(type => {
            if (enabled) {
                document.addEventListener(type, unlock, true)
            } else {
                document.removeEventListener(type, unlock, true)
            }
        })
    }

    setUnlockListeners(true)

    // false — звук не прозвучал: вкладка скрыта или браузер его заблокировал
    const play = (audio: HTMLAudioElement, errorMessage: string): Promise<boolean> => {
        if (document.hidden) {
            return Promise.resolve(false)
        }
        audio.currentTime = 0
        return audio.play().then(() => true).catch(err => {
            console.warn(errorMessage, err)
            // Разблокировка была ложной (muted-запуск iOS пускает и без жеста) — ждём следующего жеста
            if (err?.name === 'NotAllowedError') {
                unlocked = false
                setUnlockListeners(true)
            }
            return false
        })
    }

    const playMessageAlert = () => play(messageAudio, 'Ошибка проигрывания звука пришедшего сообщения:')

    const playNotificationAlert = () => play(notificationAudio, 'Ошибка проигрывания звука уведомления:')

    return { playMessageAlert, playNotificationAlert }
}

export function useSoundAlert() {
    if (!soundAlertInstance) {
        soundAlertInstance = createSoundAlertService()
    }
    return soundAlertInstance
}
